var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAddNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-246.000000, -754.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(49.000000, 752.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205,2 C200.584,2 197,5.584 197,10 C197,14.416 200.584,18 205,18 C209.416,18 213,14.416 213,10 C213,5.584 209.416,2 205,2 Z M209,10.8 L205.8,10.8 L205.8,14 L204.2,14 L204.2,10.8 L201,10.8 L201,9.2 L204.2,9.2 L204.2,6 L205.8,6 L205.8,9.2 L209,9.2 L209,10.8 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add_new.bb64c9f9.svg";
export { ForwardRef as ReactComponent };